"use client";

import { Sidebar } from "@/components/sidebar/Sidebar";
import { AnnouncementBanner } from "@/components/AnnouncementBanner";
import { CompanyNoticeToast } from "@/components/CompanyNoticeToast";
import { AccentColorProvider } from "@/components/AccentColorProvider";
import { SettingsModal } from "@/components/settings/SettingsModal";
import { SusSurveyGlobalPrompt } from "@/components/surveys/SusSurvey";
import { ProtectedSessionGate } from "@/components/auth/ProtectedSessionGate";
import { Suspense } from "react";
import { usePathname } from "next/navigation";

export default function SidebarLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  const isStandalonePaymentRoute =
    pathname?.startsWith("/payment/") || pathname?.startsWith("/billing/");

  // Sidebar.tsx 의 hideHeaderOnDesktop 과 일치해야 함.
  const hideHeaderOnDesktop =
    pathname === "/c" ||
    pathname === "/projects" ||
    pathname?.startsWith("/projects/") ||
    pathname?.startsWith("/artifacts") ||
    pathname === "/plans";

  const content = (
    <AccentColorProvider>
      <div className="seexr-sidebar-surface flex h-[100dvh] w-full overflow-hidden relative">
        {!isStandalonePaymentRoute && (
          <Suspense fallback={null}>
            <Sidebar />
          </Suspense>
        )}
        <main
          id="main-content"
          className={`min-w-0 flex-1 flex flex-col relative h-full overflow-hidden bg-background transition-all duration-150 ease-out origin-right ${hideHeaderOnDesktop || isStandalonePaymentRoute ? "" : "md:pt-[60px]"}`}
        >
          {/* Company news floats independently from the workspace. */}
          {!isStandalonePaymentRoute && <AnnouncementBanner />}

          {/* Content Area */}
          <div className="min-w-0 flex-1 flex flex-col overflow-hidden w-full relative">
            {children}
          </div>
        </main>
        {!isStandalonePaymentRoute && <CompanyNoticeToast />}
        {!isStandalonePaymentRoute && <SettingsModal />}
        {!isStandalonePaymentRoute && <SusSurveyGlobalPrompt />}
      </div>
    </AccentColorProvider>
  );

  // 결제 callback/process 화면은 기존 동작을 유지하고, Sidebar 제품 화면만
  // history/bfcache session reconcile 경계 안에 둔다.
  return isStandalonePaymentRoute ? (
    content
  ) : (
    <ProtectedSessionGate>{content}</ProtectedSessionGate>
  );
}
